export const Primitives = [
  "name",
  "label",
  "text",
  "number",
  "boolean",
  "select",
  "state",
  "ui-event"
];



// WEBPACK FOOTER //
// ./src/primitives.js